import { define } from 'wicked-elements'
import OpenSeadragon from 'openseadragon'

define('[data-component~="zoom-image"]', {
  connected () {
    const status = this.element.querySelector('[data-zoom-status]')
    let source
    try {
      source = new URL(this.element.dataset.source, document.baseURI)
    } catch {
      status.textContent = 'Please provide a valid .dzi path or URL.'
      return
    }
    if (!['http:', 'https:'].includes(source.protocol) || !/\.dzi$/i.test(source.pathname)) {
      status.textContent = 'Please provide a valid .dzi path or URL.'
      return
    }
    this.viewer = OpenSeadragon({
      element: this.element.querySelector('[data-zoom-canvas]'),
      tileSources: source.href,
      zoomInButton: this.element.querySelector('[data-zoom-in]'),
      zoomOutButton: this.element.querySelector('[data-zoom-out]'),
      homeButton: this.element.querySelector('[data-zoom-home]'),
      fullPageButton: this.element.querySelector('[data-zoom-fullscreen]'),
      showNavigator: true,
      navigatorBorderColor: 'transparent',
      navigatorBackground: 'transparent',
      visibilityRatio: 1,
      constrainDuringPan: true,
      maxZoomPixelRatio: 4,
      gestureSettingsMouse: { scrollToZoom: true }
    })
    this.viewer.addHandler('open', () => { status.hidden = true })
    this.viewer.addHandler('open-failed', () => {
      status.hidden = false
      status.textContent = 'Image unavailable. Check the URL and that its Deep Zoom tiles have been prepared.'
    })
  },
  disconnected () {
    this.viewer?.destroy()
  }
})
